export enum SQSEventEnum {
    FIRST_PAYMENT_SUCCESS = "FIRST_PAYMENT_SUCCESS",
    BALANCE_PAYMENT_SUCCESS = "BALANCE_PAYMENT_SUCCESS",
    STRIPE_UK_SCHEDULED_PAYMENT_EXECUTED = "STRIPE_UK_SCHEDULED_PAYMENT_EXECUTED"
}